<template>
    <div style="font-size: 23.4375px;">
        <!--    导航栏-->
        <Anav pro="2"></Anav>
        <!--    标签栏-->
        <Atablebar></Atablebar>
        <div class="boxDiv">
            <van-collapse v-model="item.problemId" accordion v-for="(item,index) in asblist" :key="index" >
                <van-collapse-item  :title="item.problem" name="1"><div v-html="item.answer"></div></van-collapse-item>
            </van-collapse>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Field, Button, Notify, Icon,Collapse, CollapseItem } from 'vant';
    //引入导航组件
    import Anav from './Acomponent/Anav';
    import Atablebar from './Acomponent/Atablebar';

    Vue.use(Field).use(Button).use(Notify).use(Collapse).use(CollapseItem).use(Icon);
    export default {
        components:{
            Anav,
            Atablebar,
        },
        name: "Aproblemdetail",
        data() {
            return {
                asblist:"",
            }
        },
        props: {
            name: {}
        },
        created() {
            this.askpreblom(this.$route.query.problemid,this.$route.query.problemName)
        },
        watch: {
            $route: {
                handler: function(val, oldVal){
                    this.askpreblom(val.query.problemid,val.query.problemName)
                },
            }
        },
        methods: {
            askpreblom(n,text){
                console.log(n+"----"+text)
                if(n==undefined){
                    n=""
                }
                if(text==undefined){
                    text=""
                }
                this.$axios.post("/product/problem?problemType="+n+"&problemName="+text).then(res=>{
                    if(res.data==0){
                        Notify({ type: 'danger', message: '没有匹配内容！'})
                    }
                    this.asblist=res.data
                })
            }

        }
    }
</script>

<style scoped>
    .boxDiv{
        padding-top: 46px;
    }

</style>
